import React from 'react';
import CmmsAssetHierarchy from '../features/cmms';

export default function CmmsAssetHierarchyPage() {
  return (
    <CmmsAssetHierarchy />
  );
}
